import { ReportStatusModel } from "../models/report-status";
import { backboneCollectionProperties } from "../../decorators/backbone-properties";

@backboneCollectionProperties({
    model: ReportStatusModel
})
export class ReportStatusCollection extends Backbone.Collection<ReportStatusModel> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/import-status/collections/report-status.ts